import { render, staticRenderFns } from "./FormAddImagen.vue?vue&type=template&id=2f2def76"
import script from "./FormAddImagen.vue?vue&type=script&lang=js"
export * from "./FormAddImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports